<template>
  <div class="dialog">
    <el-dialog :visible.sync="changVisible" :title="title" center width="400px" :before-close="$onClose" destroy-on-close>
      <el-input v-model="operators" placeholder="发货快递"></el-input>
      <el-input v-model="express_number" placeholder="发货单号" style="margin-top: 40px"></el-input>

      <div class="footDialog">
        <el-button style="width: 106px; float: right" size="small" type="primary" v-preventReClick @click="save()">保存</el-button>
        <el-button style="width: 106px; float: right; margin-right: 15px" size="small" @click="close()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/strUtils'
import * as Utils from '@/utils/utils.js'
import preventReClick from '@/utils//preventReClick' //防多次点击，重复提交
var thisInfo = {}

export default {
  data() {
    return {
      changVisible: false,
      integralType: false,
      title: '票据发货',
      operators: '',
      express_number: '',
      clickLastTime: 0 //默认上一次点击时间为0
    }
  },
  methods: {
    $onClose(done) {
      done()
    },
    close() {
      this.changVisible = false
    },
    save() {
      let clickNow = new Date().valueOf()
      if (clickNow - this.clickLastTime < 2000) return
      this.clickLastTime = clickNow

      if (isEmpty(this.operators)) {
        Utils.showErrorMsg(this, '请输入发货快递', 2000)
        return
      }
      if (isEmpty(this.express_number)) {
        Utils.showErrorMsg(this, '请输入发货单号', 2000)
        return
      }

      if (this.integralType) {
        this.$api
          .updateIntegralMail({
            token: localStorage.getItem('token'),
            order_id: this.id,
            operators: this.operators,
            express_number: this.express_number
          })
          .then(({ data }) => {
            this.$emit('toSave')
            this.changVisible = false
          })
      } else {
        this.$api
          .updateDonationMail({
            token: localStorage.getItem('token'),
            id: this.id,
            operators: this.operators,
            express_number: this.express_number
          })
          .then(({ data }) => {
            this.$emit('toSave')
            this.changVisible = false
          })
      }
    },
    //页面初始化时加载的事件
    show(id, operators, express_number, title) {
      this.id = id
      this.operators = operators
      this.express_number = express_number
      this.title = title
      this.changVisible = true
    },
    //页面初始化时加载的事件
    showIntegral(id, operators, express_number) {
      this.integralType = true
      this.show(id, operators, express_number, '票据发货')
    }
  }
}
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/journalExpressDialog.vue